import styled from 'styled-components'

import { useRegionPlacePagesQuery } from 'hooks/useQueries'

import PaginatedSlides from '../../../../components/display/PaginatedSlides'
import PlaceCard from '../../../../components/cards/PlaceCard'

import { IntroTitle } from '../styled'

const Section = styled.section`
  --paginated-slides-gutter: var(--ds-space-05);
  margin-top: var(--ds-space-07);
`

type RegionPlacePagesProps = {
  regionId: string
  regionName: string
}

const noop = () => {}

const RegionPlacePages = ({ regionId, regionName }: RegionPlacePagesProps) => {
  const { data } = useRegionPlacePagesQuery({
    variables: { regionId },
    fetchPolicy: 'cache-first',
  })
  const placePages = data?.region?.placePages

  if (!placePages?.length) return null

  const items = placePages.map((page) => ({ id: page.id, page }))

  return (
    <Section aria-labelledby="region-places">
      <PaginatedSlides
        customTitle={
          <IntroTitle id="region-places">
            Places in <em>{regionName}</em>
          </IntroTitle>
        }
        called
        loading={false}
        canFetchMore={false}
        onFetchMore={noop}
        items={items}
        ItemComponent={PlaceCard}
        minHeight="0"
        variant="compact"
      />
    </Section>
  )
}

export default RegionPlacePages
